// TODO: Change this to `3xl and 4xl`
export const fontSizes = {
    xxxxl: 56,
    xxxl: 40,
    xxl: 32,
    xl: 24,
    l: 20,
    m: 16,
    s: 14,
    xs: 12,
    xxs: 10,
};
export const fontWeights = {
    light: 300,
    regular: 400,
    semiBold: 600,
};
export const lineHeights = {
    xxxxl: '64px',
    xxxl: '52px',
    xxl: '42px',
    xl: '32px',
    l: '28px',
    m: '24px',
    s: '22px',
    xs: '20px',
    xxs: '16px',
};
export const fonts = {
    body: "var(--font-work-sans, 'Work Sans'), sans-serif",
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwb2dyYXBoeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90aGVtZS90eXBvZ3JhcGh5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLHFDQUFxQztBQUNyQyxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQXVCO0lBQzNDLEtBQUssRUFBRSxFQUFFO0lBQ1QsSUFBSSxFQUFFLEVBQUU7SUFDUixHQUFHLEVBQUUsRUFBRTtJQUNQLEVBQUUsRUFBRSxFQUFFO0lBQ04sQ0FBQyxFQUFFLEVBQUU7SUFDTCxDQUFDLEVBQUUsRUFBRTtJQUNMLENBQUMsRUFBRSxFQUFFO0lBQ0wsRUFBRSxFQUFFLEVBQUU7SUFDTixHQUFHLEVBQUUsRUFBRTtDQUNSLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxXQUFXLEdBQXlCO0lBQy9DLEtBQUssRUFBRSxHQUFHO0lBQ1YsT0FBTyxFQUFFLEdBQUc7SUFDWixRQUFRLEVBQUUsR0FBRztDQUNkLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxXQUFXLEdBQXlCO0lBQy9DLEtBQUssRUFBRSxNQUFNO0lBQ2IsSUFBSSxFQUFFLE1BQU07SUFDWixHQUFHLEVBQUUsTUFBTTtJQUNYLEVBQUUsRUFBRSxNQUFNO0lBQ1YsQ0FBQyxFQUFFLE1BQU07SUFDVCxDQUFDLEVBQUUsTUFBTTtJQUNULENBQUMsRUFBRSxNQUFNO0lBQ1QsRUFBRSxFQUFFLE1BQU07SUFDVixHQUFHLEVBQUUsTUFBTTtDQUNaLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxLQUFLLEdBQW1CO0lBQ25DLElBQUksRUFBRSxnREFBZ0Q7Q0FDdkQsQ0FBQyJ9